import React from 'react';

export const STATES = ['FL','NJ','TX','CA','NY','GA','NC','PA','OH','IL','AZ','CO','WA','TN','Other'];
export const INDUSTRIES = ['Commercial real estate','Healthcare / hospital','Hotel / hospitality','Manufacturing / industrial','Government / municipal','Residential / multifamily','Construction / GC','Retail / mixed-use','Other'];
export const FW_TRIGGERS = ['Sprinkler impairment','Hot work / welding','Alarm system offline','Post-fire monitoring','AHJ requirement','Insurance requirement','Other'];
export const REFERRAL_SOURCES = ['Direct / inbound','Sprinkler contractor','Alarm contractor','Insurance broker','Property manager','Academy referral','Returning client','Google / search','Other'];
export const DISPATCH_STATUSES = ['Dispatched','Active','Completed','Declined — capacity','Declined — geography','Declined — other'];
export const COURSES = ['FWA Level 1 — Full certification','Hot work fire watch','Impairment coordinator','NFPA 25 overview','Corporate custom program'];
export const ENROLLMENT_TYPES = ['Individual','Corporate — 1–2 seats','Corporate — 3–9 seats','Corporate — 10+ seats'];
export const PARTNER_TYPES = ['Sprinkler contractor','Alarm system company','Extinguisher service','Fire protection GC','Insurance broker','Property manager'];
export const PARTNER_STATUSES = ['prospect','outreach','meeting','active'];
export const PRIORITY_TAGS = ['critical','high','nice_to_have'];
export const PHASES = ['phase5','phase6','phase7','phase8','post_launch'];
export const THREAT_LEVELS = ['low','medium','high','critical'];
export const ORG_ROLES = ['fire_watch_provider','ahj','property_manager','other'];
export const AHJ_STAGES = ['inbound','reqs','pilot','mandate'];
export const AHJ_STAGE_LABELS = { inbound: 'Inbound request', reqs: 'Requirements documented', pilot: 'Pilot / beta agreed', mandate: 'Mandate issued' };
export const ENTITY_LABELS = { national: 'REDLINE HQ', florida: 'REDLINE FL', newjersey: 'REDLINE NJ', academy: 'Fire Watch Academy', technologies: 'Fire Watch Technologies' };

export function Field({ label, children, full }) {
  return (
    <div className={"form-field" + (full ? " full" : "")}>
      <label className="field-label">{label}</label>
      {children}
    </div>
  );
}

export function Input({ value, onChange, placeholder, type = 'text', required }) {
  return <input type={type} value={value} onChange={onChange} placeholder={placeholder} required={required} className="field-input" />;
}

export function Select({ value, onChange, options, placeholder }) {
  return (
    <select value={value} onChange={onChange} className="field-select">
      {placeholder && <option value="">{placeholder}</option>}
      {options.map(o => typeof o === 'string'
        ? <option key={o} value={o}>{o}</option>
        : <option key={o.value} value={o.value}>{o.label}</option>
      )}
    </select>
  );
}

export function Textarea({ value, onChange, placeholder }) {
  return <textarea value={value} onChange={onChange} placeholder={placeholder} className="field-textarea" />;
}

export function FormGrid({ children, cols }) {
  return <div className={cols === 3 ? 'form-grid-3' : 'form-grid'}>{children}</div>;
}

export function SectionLabel({ children }) {
  return <div className="form-section-label">{children}</div>;
}

export function Badge({ children, variant }) {
  return <span className={"badge badge-" + (variant || 'gray')}>{children}</span>;
}

export function SaveMessage({ show, text, error }) {
  if (!show) return null;
  return <div className={"save-msg " + (error ? 'save-msg-error' : 'save-msg-success')}>{text}</div>;
}

export function Card({ children, style }) {
  return <div className="card" style={style}>{children}</div>;
}

export function CardHeader({ title, hint, action }) {
  return (
    <div className="card-header">
      <span className="card-title">{title}</span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {hint && <span className="card-hint">{hint}</span>}
        {action}
      </div>
    </div>
  );
}

export function SubmitBtn({ onClick, loading, children, sm }) {
  return (
    <button onClick={onClick} disabled={loading} className={"btn btn-primary" + (sm ? " btn-sm" : "")}>
      {loading ? 'Saving…' : children}
    </button>
  );
}

export function SecondaryBtn({ onClick, children, sm }) {
  return (
    <button onClick={onClick} className={"btn btn-secondary" + (sm ? " btn-sm" : "")}>
      {children}
    </button>
  );
}

export function EmptyState({ text, action, actionLabel }) {
  return (
    <div className="empty-state">
      {text}
      {action && <> <span className="empty-state-link" onClick={action}>{actionLabel}</span></>}
    </div>
  );
}

export function RecordMeta({ submitter, date }) {
  if (!submitter && !date) return null;
  return (
    <div className="list-row-submitter">
      {submitter}{submitter && date ? ' · ' : ''}{date ? new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''}
    </div>
  );
}

export function Avatar({ name, colorClass }) {
  const initials = (name || '?').split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
  return <div className={"avatar " + (colorClass || 'avatar-blue')}>{initials}</div>;
}
